import PaypalSitewideSearch from 'paypal-sitewide-search';

const isTouch = 'ontouchstart' in window;
const SitewideSearch = new PaypalSitewideSearch({
	// in touch mode, the search UI should just take up the whole screen
	detectPosition: !isTouch,
	trafficSource: 'walletexpnodeweb'
});

export default SitewideSearch;


// WEBPACK FOOTER //
// ./widgets/sitewideSearch.es6